import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import apiClient from "@/lib/api/client";

export function useDeleteChatAttachment(): UseMutationResult<
  Response,
  Error,
  number
> {
  return useMutation({
    mutationFn: async (attachmentId: number) =>
      apiClient.url(`/stories/attachment/${attachmentId}`).delete().res(),
    onError: (error: Error) => {
      console.error("Failed to delete chat attachment:", error);

      toast.add(
        {
          description: error.message || "Please try again later",
          title: "Error deleting attachment",
          type: "error",
        },
        {
          timeout: 5000,
        },
      );
    },
    onSuccess: () => {
      toast.add(
        {
          title: "Attachment deleted successfully",
          type: "success",
        },
        {
          timeout: 3000,
        },
      );
    },
  });
}
